<template lang="pug">
// AVAILABLE PAGE TEMPLATES:
// - TODO
// AVAILABLE SECTION TEMPLATES:
// - content-slider (optional images & link)
// - collection-grid (textual + optional images & link) / collection-grid-img (img only)
// - collection-list (optional images & link)
// - textblock-img-left / textblock-img-right / textblock-img-alternate
// - pagefooter
// - article

div.main-container(:class="this.template")
  navigation
  main.page
    section#opening.row.fullwidth
      div#hero
        div#heroborder-1
        div.parallaxContainer(v-parallax="0.1")
          div#herosection-1
            div#heroImage
        div.parallaxContainer(v-parallax="0.05")
          div#herosection-2
        div#heroborder-2
      .page-header
        h1
          vue-markdown(:source='this.title')
        vue-markdown.desc(:source='this.desc')
      div#people
        img(src="../assets/img/people.png" alt="digigurus")

    section(v-for="(n, i) in this.sections" class="row")
      component(:is="kebabToCamel(n.fields.templateId)" :payload="n")
    section(class="row fullwidth sitefooter")
      pageFooter(v-if="this.pageFooter" :domainInfo="this.appData.root.fields" :payload="this.pageFooter")
</template>

<script>
// import Vue from 'vue'
import pageBase from '@/scenes/_pageBase.js'

// import { kebabToCamel } from '@/helpers'

export default {
  name: 'defaultScene',
  mixins: [pageBase],
  data: function () {
    return {}
  },
  components: {},
  methods: {
  },
  mounted () {
  }
}

</script>

<style scoped lang="scss">
#opening{
  margin-bottom: measure(xxs, true);
}

#people{
  position: absolute;
  right: 0;
  top: 50vh;
  width: 45%;

  @include breakpoint(small only){
    display: none;
  }
}

#hero{
  // overflow-x: hidden;
  width: 100vw;
  height: 110vw;
  // max-height: 1024px;
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;

  img{
    display: block;
    height: 100%;
    width: 100%;
  }

  #herosection-1{
    position: absolute;
    width: 110vw;
    height: 150vh;

    @include breakpoint (medium only) {
      max-height: 130vh;
    }
    @include breakpoint (large) {
    }

    overflow: hidden;

    transform: rotate(10deg) translate(#{measure(xxs, true) - 3vw}, -30%);
    transform-origin: top right;

    background-image: linear-gradient(-144deg, #5166E6 0%, #003BDC 60%);
    border-radius: 120px;

    @include breakpoint(small only) {
      max-height: 768px;
      // transform: rotate(10deg) translate(#{measure(xxs, true) - 3vw}, -#{measure(xs,true) + 40vw});
    }
  }
  #heroImage{
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: .2;
    background: transparent url('../assets/img/bg.png');
    background-size: cover;
  }

  #herosection-2{
    position: absolute;
    width: 55vw;
    height: 100vh;
    transform: rotate(-25deg) translate(30vw, 25vh);
    transform-origin: top right;

    background-image: linear-gradient(-145deg, #003BDC00 0%, #003bdc00 30%, #003bdc4d 45%, #003bdc 65%, #5166E6 95%);
    border-radius: 120px;
  }

  #heroborder-1{
    position: absolute;
    width: 130vw;
    height: 180vh;
    // overflow: hidden;

    transform: rotate(10deg) translate(6vw, -45vh);
    transform-origin: top right;

    border: 2px solid get-color(primary-plus2);
    opacity: .3;

    border-radius: 120px;
  }
  #heroborder-2{
    position: absolute;
    width: 140vw;
    height: 190vh;
    // overflow: hidden;

    transform: rotate(10deg) translate(6vw, -45vh);
    transform-origin: top right;

    border: 1px solid get-color(primary-plus2);
    opacity: .3;

    border-radius: 120px;
  }
}
</style>



// WEBPACK FOOTER //
// src/scenes/defaultScene.vue